import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Star } from 'lucide-react';

const RESULTS = [
  { pair: 'XAUUSD', pct: '+3.2%', note: 'London breakout', verified: true },
  { pair: 'EURUSD', pct: '+1.6%', note: 'NY retrace', verified: true },
  { pair: 'GBPJPY', pct: '+2.4%', note: 'Swing setup', verified: true },
  { pair: 'USDJPY', pct: '+1.1%', note: 'Scalp', verified: true },
  { pair: 'BTCUSD', pct: '+4.8%', note: '4H continuation', verified: true },
  { pair: 'XAUUSD', pct: '+2.7%', note: 'Asia open', verified: true },
];

const TESTIMONIALS = [
  { name: 'Rafi H.', where: 'Dhaka, BD', quote: 'For the first time my account survived a full month. Rules over feelings. Thank you AlveeTrade.' },
  { name: 'Karan P.', where: 'Mumbai, IN', quote: 'Hindi breakdowns helped me get it. Stopped revenge trading. Slow and steady now.' },
  { name: 'James M.', where: 'London, UK', quote: 'The signals are solid, but the mentorship made the real difference. Discipline is everything.' },
  { name: 'Aisha K.', where: 'Karachi, PK', quote: 'Risk management rules changed my trading forever. Smallest accounts, biggest results.' },
];

export default function Testimonials() {
  return (
    <section className="section-pad bg-[hsl(0_0%_4%)]">
      <div className="container-x space-y-10">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-2">Recent Wins · Verified</div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl leading-none">Real Trades. Real Numbers.</h2>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-2 snap-x" data-testid="results-strip">
          {RESULTS.map((r, i) => (
            <div key={i} className="snap-start min-w-[200px] card-surface rounded-2xl p-4">
              <div className="flex items-center justify-between">
                <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{r.pair}</div>
                {r.verified && <Badge className="bg-[rgba(34,199,132,0.15)] text-[hsl(152_78%_55%)] border border-[rgba(34,199,132,0.35)]">Verified</Badge>}
              </div>
              <div className="font-display uppercase text-3xl mt-3 text-[hsl(43_92%_56%)]">{r.pct}</div>
              <div className="text-xs text-muted-foreground mt-1">{r.note}</div>
            </div>
          ))}
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {TESTIMONIALS.map((t, i) => (
            <Card key={i} className="card-surface" data-testid="testimonial-card">
              <CardContent className="p-6 space-y-3">
                <div className="flex items-center gap-1 text-[hsl(43_92%_56%)]">
                  {[...Array(5)].map((_, j) => <Star key={j} className="h-4 w-4" fill="currentColor" />)}
                </div>
                <p className="text-[15px] leading-relaxed">“{t.quote}”</p>
                <div className="text-xs text-muted-foreground">— {t.name} · {t.where}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
